

/// <reference path="IntegratorSync.ts" />

// Generated class IntegratorSAPStockNoteLine_ManagedObject

class IntegratorSAPStockNoteLine_ManagedObject extends IntegratorSync
{
}
